export class SelectOption {
  label: string;
  value: string;
  constructor(value: string, label: string) {
    this.value = value;
    this.label = label;
  }
}
